export var FilterType;
(function (FilterType) {
    FilterType["Range"] = "range";
    FilterType["Values"] = "values";
    FilterType["Location"] = "location";
    FilterType["Unselected"] = "unselected";
    FilterType["Date"] = "date";
    FilterType["Radio"] = "radio";
    FilterType["None"] = "none";
})(FilterType || (FilterType = {}));
